exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".a.open_list[data-v-7faa6b6c]{margin-top:.32rem;padding-left:.427rem;padding-bottom:.32rem}.vft_large .a.open_list[data-v-7faa6b6c]{padding-left:16PX}.vft_huge .a.open_list[data-v-7faa6b6c],.vft_max .a.open_list[data-v-7faa6b6c]{padding-left:24PX}", ""]);

// exports
